<template>
    <div class="rates-info d-flex justify-content-lg-start">
        <i class="icon-check-shield d-flex"></i>
        <div class="d-flex flex-wrap justify-content-center justify-content-lg-start rate-info-text">
            <span class="eligibility-header mr-1" v-tippy="tooltipOptions">
                {{ eligibilityText }}
                <i class="fa fa-info-circle"></i>
            </span>
        </div>
    </div>
</template>

<script>
import inRange from 'lodash/inRange'

export default {
    props: ['offer', 'isAlternativeOffer', 'isDebtSolutionOffer'],
    data() {
        return {
            tooltipOptions: {
                content: null,
                trigger: 'click',
                arrow: true,
            },
        }
    },
    created() {
        this.tooltipContentFill()
    },
    computed: {
        eligibilityText: function () {
            if (this.offer.likelihood && !this.isAlternativeOffer && !this.isDebtSolutionOffer) {
                if (this.offer.likelihood >= 80)
                    return this.$t('results.offerBlocks.eligibility.likelihood.outstanding')
                else if (inRange(this.offer.likelihood, 70, 79))
                    return this.$t('results.offerBlocks.eligibility.likelihood.excellent')
                else if (inRange(this.offer.likelihood, 60, 69))
                    return this.$t('results.offerBlocks.eligibility.likelihood.great')
                else if (inRange(this.offer.likelihood, 50, 59))
                    return this.$t('results.offerBlocks.eligibility.likelihood.good')
                else if (inRange(this.offer.likelihood, 49))
                    return this.$t('results.offerBlocks.eligibility.likelihood.fair')
            }

            return this.$t('results.offerBlocks.eligibility.likelihood.eligible')
        },
    },
    methods: {
        tooltipContentFill: function () {
            this.tooltipOptions.content = this.$t('results.offerBlocks.eligibility.toolTipText')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import 'v-tooltip/dist/v-tooltip.css';

.icon-question-mark {
    height: 22px;
    margin-left: 15px;
    min-width: 15px;
    position: relative;

    @media screen and (min-width: $bp-medium) {
        min-width: 18px;
    }

    &:before {
        content: var(--url-question-mark-circle);
        height: 100%;
        position: absolute;
        top: 2px;
        width: 100%;
    }
}

.icon-check-shield {
    height: 100%;
    margin-right: 5px;
    min-width: 15px;
    position: relative;

    @media screen and (min-width: $bp-medium) {
        min-width: 18px;
        margin-right: 15px;
    }

    &:before {
        content: var(--url-check-shield);
        left: 50%;
        position: absolute;
        top: calc(50% + 2px);
        transform: translate(-50%, -50%);
        width: 100%;
    }
}

.rates-info {
    border-radius: 30px;
    border: 1px solid #e5e5e5;
    color: #808080;
    font-family: var(--primary-font);
    font-size: rem(14px);
    font-weight: 600;
    margin-bottom: 12px;
    padding: 10px;
    width: 100%;

    @media screen and (min-width: $bp-large) {
        width: initial;
    }

    .smaller-info {
        span {
            font-size: rem(13px);

            @media screen and (min-width: $bp-medium) {
                font-size: rem(14px);
            }
        }
    }

    span {
        color: black;
        font-size: rem(12px);
        font-weight: 600;
        text-align: center;

        @media screen and (max-width: $bp-small) {
            font-size: rem(14px);
        }

        @media screen and (min-width: $bp-medium) {
            font-size: rem(14px);
        }

        &.light-text {
            color: #808080;
        }
    }

    .eligibility-header {
        cursor: pointer;

        .fa-info-circle {
            margin-left: 5px;
            color: #808080;
        }
    }

    .rate-info-text {
        width: 100%;
    }
}
</style>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.v-popper__wrapper {
    max-width: 900px;

    .v-popper__inner {
        font-size: rem(13px);

        div {
            color: white;
        }
    }
}
</style>
